import script from "./payroll-period-adjustments.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-period-adjustments.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__